module.exports = "/assets/fonts/9ed13bbe.svg";